import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import IGroupKey from "../interfaces/IGroupKey";
import { GetListStatusForm } from "../services/form";


const useListStatusForm = () => {

    // States
    const [listStatusForm, setListStatusForm] = useState<IGroupKey[]>([]);
    const [loadingListStatusForm, setLoadingListStatusForm] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetAttributesByUserID();
    }, [])

    // Handles
    const handleGetAttributesByUserID = () => {
        setLoadingListStatusForm(true);
        tryCatch(() => {
            GetListStatusForm()
                .then((response) => {
                    setListStatusForm(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingListStatusForm(false));
        })
    }

    return {
        listStatusForm,
        loadingListStatusForm,
    }
}


export default useListStatusForm;
